import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {faExclamationTriangle} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'app-modal-yesnocancel',
  template: `
    <div class="modal-header">
      <h4 class="modal-title" id="modal-title">{{title}}</h4>
      <button [hidden]="hideCloseBtn" type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
              (click)="modal.dismiss(false)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
      <div class="modal-body">
        <fa-icon *ngIf="showWarningIcon" [icon]="icons.warning" class="text-warning"></fa-icon>
        <ng-container>{{text}}</ng-container>
      </div>
    <div class="modal-footer">
      <button type="button" ngbAutofocus class="btn btn-success"
              (click)="modal.close(true)">{{yesBtn}}
      </button>
      <button type="button" class="btn btn-danger"
              (click)="modal.close(false)">{{noBtn}}
      </button>
      <ng-container *ngIf="!hideCancelBtn" >
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss(false)">{{cancelBtn}}
        </button>
      </ng-container>
    </div>
  `
})
export class YesNoCancelModalComponent {
  @Input() text;
  @Input() title = "Сообщение";
  @Input() yesBtn = "Да";
  @Input() noBtn = "Нет";
  @Input() cancelBtn = "Отмена";
  @Input() hideCloseBtn = false;
  @Input() showWarningIcon = false;
  @Input() hideCancelBtn = false;
  icons = {
    warning: faExclamationTriangle
  };
  constructor(public modal: NgbActiveModal) {
  }
}
